/* eslint-disable no-restricted-imports */
import React, {useMemo} from 'react'
import styles from './Logo.module.scss'
import {useUIGameEndContext} from '../../../../contexts/UIGameEndContext'
import {TranslationObject} from '@colonist/i18n'
import {PlayerColor} from '@colonist/game-states'
import {T} from '../../../../common/T'
import clsx from 'clsx'
import {FADE_IN_ANIMATION_DELAYS} from '../../constants'
import {turnSecondsInToTimerFormat} from '../../../../../../../code/client/shared/scripts/ui_utils/ClientUtils'
import {getLobbyImagePath} from '../../../../../../../code/client/shared/scripts/ui_utils/Utils'
import {LobbyImage, ModeSettingEnum} from '@colonist/types'
import {useUIGameManagerContext} from '../../../../contexts/UIGameManagerContext'
import {FadeInContainer} from '../../../../common/FadeInContainer'

export function Logo({disableAnimation}: {disableAnimation: boolean}) {
    const gameManager = useUIGameManagerContext()
    const isBeginnerMode = gameManager.gameState.gameModeData.modeSetting == ModeSettingEnum.BeginnerModeClassic4P
    const {gameEndData, currentPlayerEndgameState, isCurrentPlayerWinner, exitGameAndGoToHome} = useUIGameEndContext()

    const endGameText: TranslationObject = useMemo(() => {
        const myColor = gameManager.gameController.myColor

        if(isBeginnerMode && !isCurrentPlayerWinner) {
            const beginnerModeLostText: TranslationObject = {key: 'strings:game.beginnerMode.opponentWon'}
            return beginnerModeLostText
        }
        const isSpectator = myColor == PlayerColor.None
        if(isSpectator) return {key: 'strings:game.endGame.rank.spectator'}

        switch(currentPlayerEndgameState?.rank) {
            case 1: return {key: 'strings:game.endGame.rank.1st'}
            case 2: return {key: 'strings:game.endGame.rank.2nd'}
            case 3: return {key: 'strings:game.endGame.rank.3rd'}
            case 4: return {key: 'strings:game.endGame.rank.4th'}
            default: return {key: 'strings:game.endGame.rank.defeat'}
        }
    }, [currentPlayerEndgameState, isBeginnerMode, isCurrentPlayerWinner])

    const timeTurnsText = useMemo(() => {
        if(isBeginnerMode && !isCurrentPlayerWinner) {
            const beginnerModeLostText: TranslationObject = {key: 'strings:game.beginnerMode.lost'}
            return beginnerModeLostText
        }
        const text: TranslationObject = {key: 'strings:game.endGame.generalStats', options: {
            timeString: turnSecondsInToTimerFormat(gameEndData.endGameState.gameDurationInMS / 1000),
            turnCount: String(gameEndData.endGameState.totalTurnCount),
        }}
        return text
    }, [gameEndData, isCurrentPlayerWinner, isBeginnerMode])

    return (
        <FadeInContainer
            animationDelayMs={FADE_IN_ANIMATION_DELAYS.logo}
            animationDurationMs={FADE_IN_ANIMATION_DELAYS.transitionDuration}
            className={clsx(styles.logoContainer)}
            disableAnimation={disableAnimation}
        >
            <img className={styles.logo} onClick={exitGameAndGoToHome} src={getLobbyImagePath(LobbyImage.Logo)} />
            <div className={styles.heading}>
                <T id={endGameText}/>
            </div>
            <div className={clsx(styles.timeTurns)}>
                <T id={timeTurnsText}/>
            </div>
        </FadeInContainer>
    )
}
